import { StarIcon } from "@heroicons/react/16/solid";
import { ArrowUpTrayIcon } from "@heroicons/react/20/solid";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import {
  FieldValues,
  RegisterOptions,
  UseFormRegister,
  useFormContext,
} from "react-hook-form";

interface FileInputBase {
  selectedFile: any;
  registerOptions?: RegisterOptions<FieldValues, string>;
  placeholder?: string;
  className?: string;
  label?: string;
  accept?: string;
  name?: string;
  isRequired?: boolean;
  textEllipsis?: number;
  containerClassWidth?: string;
}

const FileInputBase = ({
  registerOptions,
  selectedFile,
  placeholder = "",
  className = "",
  label = "",
  accept = "",
  name = "",
  isRequired = true,
  textEllipsis = 25,
  containerClassWidth = "",
}: FileInputBase) => {
  const {
    register,
    formState: { errors },
    watch,
  }: {
    register: UseFormRegister<FieldValues>;
    formState: { errors: any };
    watch: any;
  } = useFormContext();
  let errorMessage = String(errors[name]?.message || "");
  if (String(name).includes(".")) {
    const [parent, index, child] = String(name).split(".");
    errorMessage = String(errors?.[parent]?.[index]?.[child]?.message || "");
  }
  return (
    <div className={`${containerClassWidth} flex flex-col`}>
      {label && (
        <label className="text-xs flex items-center gap-1 text-left text-body font-semibold pl-1">
          {label}
          {(registerOptions?.required || isRequired) && (
            <StarIcon className="size-2 text-error -translate-y-1" />
          )}
        </label>
      )}
      <label
        className={`relative cursor-pointer bg-white rounded-md w-full px-2
        h-10 flex items-center justify-center gap-2 border-dotted border-2  ${errorMessage ? "border-error " : "border-primary "
          } ${className}`}
      >
        <span
          className={`  ${errorMessage ? "text-error " : "text-primary "} `}
        >
          <ArrowUpTrayIcon width={20} height={20} />
        </span>

        <span
          className={`text-sm font-medium  relative text-ellipsis w-full 
        overflow-hidden ${errorMessage ? "text-error " : "text-primary"}`}
        >
          {stringUtility?.addEllipsisAtEnd(
            watch(name)?.[0]?.name,
            textEllipsis
          ) ||
            selectedFile?.[0]?.name ||
            placeholder}
        </span>

        <input
          {...register(name, registerOptions)}
          type="file"
          id="fileInput"
          className="opacity-0 absolute w-0 h-0"
          accept={accept}
        />
      </label>
      {errorMessage && (
        <p className="text-xs text-error font-medium pl-2 mt-0.5">
          {`${errorMessage}`}
        </p>
      )}
    </div>
  );
};

export default FileInputBase;
